<template>
    <v-container fluid class="full-height">
        <v-row>
            <v-col cols="12" sm="6" md="6">
                <v-row>
                    <v-col cols="12" sm="12" md="12">
                        <v-text-field v-model="search" prepend-icon="mdi-magnify" label="Search" clearable
                            clear-icon="mdi-close-circle"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12" md="12">
                        <div v-if="selected.length > 0" style="height: 250px; overflow-y: auto;" class="text-center">
                            <v-chip v-for="item in selected" :key="item.ECHT_PARTNER_ID" class="ma-1" label
                                :color="item.Dirty == 0 ? 'red' : 'cyan'">
                                {{ item.short_name }}
                            </v-chip>
                        </div>
                        <div v-if="selected.length == 0" style="height: 250px; overflow-y: auto;" class="text-center">
                            <v-chip outlined disabled class="ma-1">
                                Keine Partner zum Bestätigen ausgewählt
                            </v-chip>
                        </div>
                    </v-col>
                    <v-col cols="12" sm="12" md="12">
                        <div class="text-center">
                            <v-btn v-if="selected.length > 0" @click="confirmPartner">Bestätigen</v-btn>
                            <v-btn v-else disabled>Bestätigen</v-btn>
                        </div>
                    </v-col>
                </v-row>
            </v-col>
            <v-col cols="12" sm="6" md="6">
                <div class="half-height">
                    <parentTable :search="search" maxheight="calc((100vh - 180px) / 2)" :editable="true"
                        ref="parentTable">
                    </parentTable>
                </div>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" sm="12" md="12">
                <div class="half-height">
                    <childTable @confirmedChilds="selectedToBeConfirmedChilds" ref="childTable" :selectable=true
                        :splitable=true></childTable>
                </div>
            </v-col>
        </v-row>
        <popupAlert :alertType="alertType" :alertMessage="alertMessage" ref="alert">
        </popupAlert>
    </v-container>
</template>

<script>
import apiPartnerService from '@/services/api/apiPartnerService';

import parentTable from './tabels/parentTable.vue';
import childTable from './tabels/childTable.vue';

import popupAlert from '../../popupAlert.vue';

export default {
    data() {
        return {
            alertType: 'error',
            alertMessage: '',
            search: '',
            selected: [],
        };
    },
    components: {
        parentTable,
        childTable,
        popupAlert
    },
    methods: {
        selectedToBeConfirmedChilds(selected) {
            this.selected = selected;
        },
        async confirmPartner() {
            if (this.selected.some(item => item.Dirty == 0)) {
                const dirtyItem = this.selected.find(item => item.Dirty == 0);

                console.log(dirtyItem);

                this.newAlert(`${dirtyItem.short_name} ist bereits bestätigt`, 'error');
                return;
            }

            this.selected.forEach(async item => {
                try {
                    const response = await apiPartnerService.setEchtPartnerDirty(item);
                    if (response != true) {
                        this.newAlert(`Fehler beim Bestätigen von ${item.short_name}`, 'error');
                        return;
                    }
                    this.newAlert(`Bestätigung von ${item.short_name} erfolgreich`, 'success');
                } catch (error) {
                    this.newAlert(`Fehler beim Bestätigen von ${item.short_name}`, 'error');
                }
            });
            await new Promise(r => setTimeout(r, 1000));

            this.$refs.childTable.refreshChilds();
            this.$refs.parentTable.refresh();
            this.selected = [];
        },
        newAlert(message, type) {
            this.alertMessage = message;
            this.alertType = type;
            this.$refs.alert.newAlert();
        }
    },
}
</script>

<style>
.full-height {
    height: calc(100vh - 160px);
}

.half-height {
    /*height: calc((100vh - 160px) / 2);*/
    max-height: calc((100vh - 180px) / 2);
    min-height: calc((100vh - 180px) / 2);
    overflow-y: auto;
}

.scrollable {
    overflow-y: scroll;
    padding: 5px;
}
</style>